import React, { useEffect, useState } from 'react';
import { Role } from '../api/types';
import {
  SimulatedRoleContext,
  SimulatedRoleSetterContext,
  useMixpanelContext,
} from '../context/contexts';

export const SimulatedRoleContextProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const mixpanel = useMixpanelContext();

  const [selectedSimulatedRole, setSelectedSimulatedRole] =
    useState<Role | null>(null);

  const toggleSimulatedRole = (role: Role | null) => {
    setSelectedSimulatedRole(role);
  };

  useEffect(() => {
    mixpanel.actions.register({ simulatedRole: selectedSimulatedRole });
  }, [mixpanel, selectedSimulatedRole]);

  return (
    <SimulatedRoleContext.Provider value={selectedSimulatedRole}>
      <SimulatedRoleSetterContext.Provider value={toggleSimulatedRole}>
        {children}
      </SimulatedRoleSetterContext.Provider>
    </SimulatedRoleContext.Provider>
  );
};
